import React from "react";
import { BaseLayout } from "@components/components";
import { formsSidebarData } from "@config/";
import { useTranslation } from "react-i18next";

export const FormsBase = () => {
    const { t } = useTranslation();
    return <BaseLayout data={formsSidebarData(t)} />;
};
